import { ONLINE_EVENTS } from '@/constants';
import { MessageDescriptor, useIntl } from 'react-intl';
import classNames from 'classnames';
import { messageDescriptorToString } from '@/utils/messageDescriptor';
import styles from './BucketHeader.module.scss';

interface BucketHeaderProps {
    currentPlace?: string;
    isPrimaryBucket?: boolean;
    isSpecialBucket?: boolean;
    titleMessage?: MessageDescriptor;
    subtitleMessage?: MessageDescriptor;
    icon?: React.ReactNode;
}

export const BucketHeader = (props: BucketHeaderProps) => {
    const intl = useIntl();

    const {
        currentPlace: rawCurrentPlace = '',
        isPrimaryBucket,
        isSpecialBucket,
        titleMessage,
        subtitleMessage,
        icon,
    } = props;

    // cast to string if it's a message descriptor (we need a string)
    const currentPlace = messageDescriptorToString(rawCurrentPlace) || '';

    if (!titleMessage && !subtitleMessage) {
        return null;
    }

    let titleComponent = null;
    let subtitleComponent = null;

    let titleText: string | null = null;
    if (titleMessage) {
        titleText = intl.formatMessage(titleMessage, { location: currentPlace });
    }

    if (currentPlace === ONLINE_EVENTS && isPrimaryBucket) {
        titleText = intl.formatMessage({
            id: 'Online Events',
            defaultMessage: 'Online Events',
        });
    }

    if (titleText) {
        titleComponent = <h2 className={styles.title}>{titleText}</h2>;
    }

    if (subtitleMessage) {
        const subtitleText = intl.formatMessage(subtitleMessage, { location: currentPlace });
        subtitleComponent = <span className={styles.subtitle}>{subtitleText}</span>;
    }

    if (!titleComponent && !subtitleComponent) {
        return null;
    }

    const bucketHeaderClassNames = classNames(styles.root, {
        [styles.premium]: isSpecialBucket,
        [styles.hasIcon]: icon,
    });

    return (
        <div className={bucketHeaderClassNames} data-testid="feed-bucket-header">
            {icon || null}
            {titleComponent}
            <div>{subtitleComponent}</div>
        </div>
    );
};
